import deleteIcon from '@src/main/assets/icons/bin-red.svg';
import pdfIcon from '@src/main/assets/icons/pdf-red.svg';
import createIcon from '@src/main/assets/icons/plus-red.svg';
import refreshIcon from '@src/main/assets/icons/refresh-red.svg';
import xlsIcon from '@src/main/assets/icons/xls-red.svg';
import { Button } from 'primereact/button';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './TableHeader.module.scss';

interface Props {
  onCreate: () => void;
  onDelete?: () => void;
  onRefresh: () => void;
  onExportExcel?: () => void;
  onExportPdf?: () => void;
  visibility: boolean[];
  exportable?: boolean;
}

const TableHeader: FC<Props> = ({
  onCreate,
  onDelete,
  onRefresh,
  onExportExcel,
  onExportPdf,
  visibility,
  exportable = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles['header-row']}>
      <div className={styles['left-group']}>
        {visibility[1] && (
          <Button
            type="button"
            className="p-button-text"
            tooltip={t('common.create')}
            tooltipOptions={{ position: 'bottom' }}
            onClick={onCreate}
            icon={<img src={createIcon} width={15} alt={t('common.create')} />}
          />
        )}
        {visibility[2] && (
          <Button
            type="button"
            className="p-button-text"
            tooltip={t('common.delete')}
            tooltipOptions={{ position: 'bottom' }}
            onClick={onDelete}
            icon={<img src={deleteIcon} width={15} alt={t('common.delete')} />}
          />
        )}
        {visibility[3] && (
          <Button
            type="button"
            className="p-button-text"
            tooltip={t('common.refresh')}
            tooltipOptions={{ position: 'bottom' }}
            onClick={onRefresh}
            icon={<img src={refreshIcon} width={15} alt={t('common.refresh')} />}
          />
        )}
      </div>

      {exportable && (
        <div className={styles['right-group']}>
          <Button
            type="button"
            className="p-button-text"
            tooltip={t('common.excel')}
            tooltipOptions={{ position: 'bottom' }}
            onClick={onExportExcel}
            icon={<img src={xlsIcon} width={20} alt={t('common.excel')} />}
          />
          <Button
            type="button"
            className="p-button-text"
            tooltip={t('common.pdf')}
            tooltipOptions={{ position: 'bottom' }}
            onClick={onExportPdf}
            icon={<img src={pdfIcon} width={20} alt={t('common.pdf')} />}
          />
        </div>
      )}
    </div>
  );
};
export default TableHeader;
